import { StoreModel } from '../../models/Index';

// eslint-disable-next-line import/no-anonymous-default-export
export default function fillStack(Store: StoreModel, data: any) {
    return Store.shellClient.cashAcceptor.cashAcceptorStack = {
        appId: data.appId,
        processId: data.processId,
        amount: data.amount
    };
}
